import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent, DialogData } from '../../common/components/dialog/dialog.component';
import { Observable } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})

/**
 *  Begründung: Diese Klasse ermöglicht es die Allgemeine Dialogcomponent zu customizen und damit auch bestimmte Anforderungen
 * zu Erfüllen, welche sich um die Hinweise an den User handeln.
 *
 */
export class DialogService {
  private readonly dialog = inject(MatDialog);

  openInfoDialog(
    dialogData: DialogData,
    width = '28.6rem',
    height = '21.8rem',
    disableClose = false
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData,
      panelClass: ['custom-dialog-container', 'info-dialog-container'],
      width,
      height,
      disableClose: disableClose
    });

    return dialogRef.afterClosed();
  }

  openWarningDialog<TData = DialogData>(
    dialogData: TData,
    width = '28.6rem',
    height = '21.8rem',
    disableClose = false,
    optionalDialog?: ComponentType<unknown>
  ): Observable<any> {
    const dialogRef = this.dialog.open(optionalDialog ?? DialogComponent, {
      data: dialogData,
      panelClass: ['custom-dialog-container', 'warning-dialog-container'],
      width,
      height,
      disableClose: disableClose
    });

    return dialogRef.afterClosed();
  }

  openInputDialog(
    dialogData: DialogData,
    width = '28.6rem',
    height = '21.8rem',
    disableClose = false
  ): Observable<string> {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData,
      panelClass: ['custom-dialog-container', 'input-dialog-container'],
      width,
      height,
      disableClose: disableClose
    });

    return dialogRef.afterClosed();
  }

  openErrorDialog(
    dialogData: DialogData,
    width = '28.6rem',
    height = '21.8rem',
    disableClose = false,
    maxHeight = '40rem'
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData,
      panelClass: ['custom-dialog-container', 'error-dialog-container'],
      width,
      minHeight: height,
      maxHeight: maxHeight,
      disableClose: disableClose
    });

    return dialogRef.afterClosed();
  }

  openSuccessDialog(
    dialogData: DialogData,
    width = '28.6rem',
    height = '21.8rem',
    disableClose = false
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData,
      panelClass: ['custom-dialog-container', 'success-dialog-container'],
      width,
      height,
      disableClose: disableClose
    });

    return dialogRef.afterClosed();
  }

  closeAllDialogs(): void {
    this.dialog.closeAll();
  }
}
